// Справочник видов спорта: цвета, подписи позиций, иконки (см. макеты).
export type SportCode = "football" | "hockey" | "basketball";

export interface SportMeta {
  code: SportCode;
  name: string;
  color: string;
  soft: string;
  /** Краткие подписи позиций по кодам из rule_sets */
  positionShort: Record<string, string>;
  positionName: Record<string, string>;
  positionPlural: Record<string, string>;
  fieldName: string;
}

export const SPORTS: Record<SportCode, SportMeta> = {
  football: {
    code: "football",
    name: "Футбол",
    color: "var(--sport-football)",
    soft: "var(--sport-football-soft)",
    positionShort: { GK: "ВРТ", DEF: "ЗАЩ", MID: "ПЗ", FWD: "НАП" },
    positionName: { GK: "Вратарь", DEF: "Защитник", MID: "Полузащитник", FWD: "Нападающий" },
    positionPlural: { GK: "Вратари", DEF: "Защитники", MID: "Полузащитники", FWD: "Нападающие" },
    fieldName: "На поле",
  },
  hockey: {
    code: "hockey",
    name: "Хоккей",
    color: "var(--sport-hockey)",
    soft: "var(--sport-hockey-soft)",
    positionShort: { G: "ВРТ", D: "ЗАЩ", F: "НАП" },
    positionName: { G: "Вратарь", D: "Защитник", F: "Нападающий" },
    positionPlural: { G: "Вратари", D: "Защитники", F: "Нападающие" },
    fieldName: "На льду",
  },
  basketball: {
    code: "basketball",
    name: "Баскетбол",
    color: "var(--sport-basketball)",
    soft: "var(--sport-basketball-soft)",
    positionShort: { G: "ЗАЩ", F: "ФРВ", C: "Ц" },
    positionName: { G: "Защитник", F: "Форвард", C: "Центровой" },
    positionPlural: { G: "Защитники", F: "Форварды", C: "Центровые" },
    fieldName: "На площадке",
  },
};

export function sportMeta(code: string | null | undefined): SportMeta {
  return SPORTS[(code as SportCode) ?? "football"] ?? SPORTS.football;
}

export function posShort(sport: string | null | undefined, pos: string): string {
  return sportMeta(sport).positionShort[pos] ?? pos;
}

export function posName(sport: string | null | undefined, pos: string): string {
  return sportMeta(sport).positionName[pos] ?? pos;
}

/** Подписи ключей детализации очков (rule_sets.scoring) */
export const BREAKDOWN_LABELS: Record<string, string> = {
  played: "выход на поле",
  minutes_60: "60+ минут",
  goal: "гол",
  goals: "гол",
  assist: "передача",
  assists: "передача",
  clean_sheet: "«сухой» матч",
  shutout: "«сухой» матч",
  win: "победа",
  save_per_3: "сэйвы",
  save_per_5: "сэйвы",
  goal_against: "пропущенный гол",
  goals_conceded_per_2: "пропущенные голы",
  yellow: "жёлтая карточка",
  red: "красная карточка",
  own_goal: "автогол",
  penalty_saved: "отбитый пенальти",
  penalty_missed: "незабитый пенальти",
  plus_minus: "+/−",
  blocked_shot_per_3: "блокированные броски",
  shot_per_4: "броски",
  penalty_minutes_per_2: "штрафные минуты",
  point: "очки",
  points: "очки",
  rebound: "подбор",
  rebounds: "подборы",
  steal: "перехват",
  steals: "перехваты",
  block: "блок-шот",
  blocks: "блок-шоты",
  turnover: "потеря",
  turnovers: "потери",
  double_double: "дабл-дабл",
  triple_double: "трипл-дабл",
  captain: "капитан ×2",
};

export function breakdownLabel(key: string): string {
  return BREAKDOWN_LABELS[key] ?? key.replaceAll("_", " ");
}
